export default "/images/f9774d7ec5ee2dae1fc4dd58396e9933.jpg";